/* Program Name: GeneralLayout.js
 **  Description: layout for a major of the application
 **
 **
 ** Project    Date        Who  Comments
 ** ---------  ----------  ---  ---------------------------------------------------
 ** IS0200241  2021-03-17  STT  Initial program
 *********************************************************************************/

/**React imports */
import React from 'react'

/**Custom Components */
import Header from './Header'
import Alerts from './Alerts'

/**Context */
import { useAlert } from '../../../Context/AlertContext'
import { getSessionCookie } from '../../../Context/SessionContext'

/**Style imports */
import SessionWindow from '../SessionWindow'
import SiteNotification from './SiteNotification'
import LoadingModal from '../Loading/LoadingModal'
import { useLoading } from '../../../Context/LoadingContext'
import Content from './Content'
import NoSessionContent from './NoSessionContent'
import UserProxy from './UserProxy'

/**GeneralLayout **************************************************************/

const GeneralLayout = (props) => {
  /****************************************************************************/
  /**Local Variables */

  //alert       > holds the true/false values of the different alerts *open/close*
  //message     > holds the message that will be displayed on the alert
  //toggelAlert > is the fucntion that toggles the values of each alerts status
  const { alert, message, siteNotify, closeSiteNote, allAlertsOff } = useAlert()

  //hook to get the current session from SessionContext
  //const session

  const { isLoading, loadingMessage } = useLoading()

  /****************************************************************************/
  /**Rendering */

  return (
    <>
      <div>
        {getSessionCookie() ? (
          <Content>
            {getSessionCookie() && <Header />}
            {props.children}
          </Content>
        ) : (
          <NoSessionContent>
            {getSessionCookie() && <Header />}
            {props.children}
          </NoSessionContent>
        )}
        <Alerts message={message} alert={alert} close={allAlertsOff} />
        <SiteNotification siteNotify={siteNotify} close={closeSiteNote} />
        <SessionWindow />
      </div>
      {isLoading && <LoadingModal message={loadingMessage} />}
    </>
  )
}

export default GeneralLayout
